import Check from 'components/Icons/Check';
import OutsideClick from 'components/OutsideClick';
import { OrderedMap } from 'immutable';
import React, { useState } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { RFI } from 'records/RFI';

interface Props {
  rfis: OrderedMap<string, RFI>;
  currentRfiId: string;
  onRfiSelection: (rfiid: string) => void;
}

const RfiVersionListDropdown: React.FC<Props> = (props: Props) => {
  const [isOpen, setisOpen] = useState(false);
  const [outsideClick, setOutsideClick] = useState(false);
  const { rfis, currentRfiId, onRfiSelection } = props;

  const toggleDropDown = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    if (!outsideClick) {
      setisOpen(!isOpen);
    }

    event.stopPropagation();
  };

  const handleOutsideClick = (): void => {
    setOutsideClick(true);
    setisOpen(false);
    setTimeout(() => setOutsideClick(false), 250);
  };

  const addBackgroundWhenOpen = (): React.CSSProperties => {
    if (!isOpen) return {};
    return {
      borderRadius: '50%',
      backgroundColor: '#DCDFE3',
    };
  };

  return (
    <>
      <Manager>
        <Reference>
          {({ ref }): React.ReactNode => (
            <div
              ref={ref}
              id="rfi-version-list-dropdown"
              className="row items-center cursor-pointer"
              onClick={(event) => toggleDropDown(event)}
            >
              <div
                className="column justify-center items-center font-size-7"
                style={{
                  paddingBottom: '.75rem',
                  width: '20px',
                  height: '20px',
                  ...addBackgroundWhenOpen(),
                }}
              >
                ...
              </div>
            </div>
          )}
        </Reference>
        <Popper placement="right">
          {({ ref, style, placement, outOfBoundaries }): React.ReactNode => {
            return isOpen && !outOfBoundaries ? (
              <div
                ref={ref}
                className="bgd-white wrem-10 b-2 ml2"
                style={{
                  ...style,
                  overflowY: 'auto',
                  width: '144px',
                  maxHeight: '154px',
                  zIndex: 4,
                }}
                data-placement={placement}
              >
                <OutsideClick
                  onOutsideClick={(evt) => {
                    handleOutsideClick();
                    evt.stopImmediatePropagation();
                  }}
                >
                  {rfis.valueSeq().map((r) => {
                    return (
                      <div
                        key={r.id}
                        className="bb-2 w100 flex-center hrem-2p75 pos-r cursor-pointer"
                        onClick={(event) => {
                          onRfiSelection(r.id);
                          event.stopPropagation();
                        }}
                      >
                        <div className="m2 font-size-4 light primary-blue">
                          RFI {r.number}
                          {r.versionnumber ? `.${r.versionnumber}` : null}
                        </div>
                        {currentRfiId === r.id && (
                          <div
                            className="pos-a primary-blue"
                            style={{
                              right: '10px',
                              bottom: '11px',
                            }}
                          >
                            <Check width="22px" height="22px" />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </OutsideClick>
              </div>
            ) : null;
          }}
        </Popper>
      </Manager>
    </>
  );
};

export default RfiVersionListDropdown;
